import { ConfigurationModel } from './config.model';

export const NGX_NUMBERS_LOCALES: Map<string, ConfigurationModel> = new Map()
  .set('cs_CZ', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'Kč',
  })
  .set('da_DK', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'kr.',
  })
  .set('de_DE', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('de_AT', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('de_CH', {
    thousandSeparator: '’',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'CHF',
  })
  .set('de_LU', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('el_GR', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('en_AU', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: true,
    currency: '$',
  })
  .set('en_CA', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'CAD',
  })
  .set('en_GB', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: true,
    currency: '£',
  })
  .set('en_HK', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: false,
    currency: 'HK$',
  })
  .set('en_IE', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('en_IN', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: false,
    currency: '₹',
  })
  .set('en_MY', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: false,
    currency: 'MYR',
  })
  .set('en_NZ', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: true,
    currency: '$',
  })
  .set('en_TH', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: true,
    currency: '฿',
  })
  .set('en_US', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: true,
    currency: '$',
  })
  .set('en_ZA', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: false,
    currency: 'ZAR',
  })
  .set('es_AR', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '$',
  })
  .set('es_CO', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '$',
  })
  .set('es_ES', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('fi_FI', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('fr_BE', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('fr_CA', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'CAD',
  })
  .set('fr_CH', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'CHF',
  })
  .set('fr_FR', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('fr_LU', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('ga_IE', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('hu_HU', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'Ft.',
  })
  .set('is_IS', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'ISK',
  })
  .set('it_CH', {
    thousandSeparator: '’',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: true,
    currency: 'CHF',
  })
  .set('it_IT', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('ja_JP', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: true,
    currency: '￥',
  })
  .set('ko_KR', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: true,
    currency: '₩',
  })
  .set('nl_BE', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('nl_NL', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('no_NO', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'kr',
  })
  .set('pl_PL', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'zł',
  })
  .set('pt_PT', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('pt_BR', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'R$',
  })
  .set('ro_RO', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'RON',
  })
  .set('ru_RU', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'RUB',
  })
  .set('sk_SK', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '€',
  })
  .set('sv_SE', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'kr',
  })
  .set('th_TH', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: true,
    currency: '฿',
  })
  .set('tr_TR', {
    thousandSeparator: '.',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '₺',
  })
  .set('zh_CN', {
    thousandSeparator: ' ',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: true,
    currency: 'CNY',
  })
  .set('zh_HK', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: false,
    currency: 'HK$',
  })
  .set('zh_TW', {
    thousandSeparator: ' ',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: true,
    currency: 'TWS',
  })

  .set('ru_NRU', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '₽',
  })
  .set('by_BYN', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'Br',
  })
  .set('ua_UAH', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '₴',
  })
  .set('kz_KZT', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: '₸',
  })
  .set('id_IDR', {
    thousandSeparator: ' ',
    decimalSeparator: ',',
    whitespaceBeforeCurrency: true,
    currency: 'Rp',
  })
  .set('COMMON', {
    thousandSeparator: ',',
    decimalSeparator: '.',
    whitespaceBeforeCurrency: false,
    currency: '',
  });
